import { Injectable } from "@angular/core";
import { ApiHttpService } from "./api-http.service";
import { Observable } from "rxjs";

@Injectable()
export class CeSiteService {
  constructor(private apiHttp: ApiHttpService) {}

  public getAll = (): Observable<CeSite[]> => {
    return this.apiHttp.get<CeSite[]>("cesites");
  };

  public get = (id: number): Observable<CeSite> => {
    return this.apiHttp.get<CeSite>(`cesites/${id}`);
  };
}

export interface CeSite {
  id: number;
  name: string;
  isActive: boolean;
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/shared/services/ce-site.service.ts